export enum MenuItemEnum {
  Apps,
  Applications,
  Flows,
  Tokens,
  Secrets,
  Chat,
  Roles,
  Permissions,
  Statistics,
  FlowActivity,
  Proxies,
  OAuthClients,
  Globals,
  Waf,
  Documentation,
}
